export default __webpack_public_path__ + "static/media/SCIENCE_BIOLOGY.6ba83ffb.svg";